import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Accordion, 
    AccordionDetails, 
    AccordionSummary,
    Grid, 
    Stack, 
    Typography, 
} from "@mui/material";

import { t, Trans } from "@lingui/macro";

import { DetailsDataProps, DetailsDataState } from "./models";

import { 
    AgeClassification, 
    Genre 
} from "models";

import { 
    ZPlayAutocomplete, 
    ZPlayChipList, 
    ZPlayDatePicker, 
    ZPlayFormField, 
    ZPlaySelect 
} from "commons/fields";
import { ZPlayLoader } from "commons";

import { RadioDefault } from "../radio-default/radio-default";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {ContentProducerService} from "services/content-producer-service";
import {withSnackbar, WithSnackbarProps} from "notistack";
import { DefaultTypedResponse } from "models/response";
import { CreateAndEditGenreModal } from "components/backoffice/genre";


export class DetailsData extends React.Component<DetailsDataProps & UseFormReturn & WithSnackbarProps, DetailsDataState> {

    constructor(props: any) {

        super(props);

        this.state = {
            openCreateGenreModal: false,
            isLoading: false,
            genreList: this.props.genreList,
            contentIssuesList: this.props.contentIssuesList,
            checkSerie: false,
        };
    }

    componentDidMount(): void {
        let checkserie = JSON.parse(this.props.getValues(`${this.props.name}.serie`));
        if(JSON.parse(checkserie))
            this.setState(() => ({checkSerie: checkserie}));
    }

    private openCreateGenreModal = (): void => {
        this.setState(() => ({openCreateGenreModal: true}));
    };

    private closeCreateGenreModal = (): void => {
        this.setState(() => ({openCreateGenreModal: false}));
    };

    private createGenreCallback = (data: any) => {
        this.props.enqueueSnackbar(t({
            id: "dd-success-create-genre",
            message: "Il genere è stato creato con successo"
        }), {
            variant: "success",
        });
        this.getGenresList();
        this.closeCreateGenreModal();
    };

    private createGenreErrorCallback = (err: any) => {
        this.props.enqueueSnackbar(t({
            id: "ms-error-create-genre",
            message: "Si è verificato un errore nella creazione del genere"
        }), {
            variant: "error",
        });
        this.closeCreateGenreModal();
    };

    private getGenresList = (): void => {
        this.setState(() => ({
            isLoading: true,
        }));
        ContentProducerService.getGenreList(this.getGenreCallback, this.getGenreErrorCallback);
    };

    private getGenreCallback = (data: DefaultTypedResponse<Genre>): void => {
        this.setState(() => ({
            genreList: data.list,
            isLoading: false
        }));
    };

    private getGenreErrorCallback = (err: any): void => {
        this.props.enqueueSnackbar(t({
            id: "dd-error-get-genres",
            message: "Si è verificato un errore. Non è stato possibile recuperare i dati"
        }), {
            variant: "error",
        });
        this.setState(() => ({
            isLoading: false,
        }));
    };

    private updateValue = (value: boolean): void => {
        this.setState(() => ({
            checkSerie: value,
        }))
    }

    render(){

        return(<>
            <Accordion sx={{backgroundColor: process.env.REACT_APP_THIRD_COLOR}}>                                
                <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{color: "white"}}/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
                >
                    <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                        <Trans id={"df-details-section"}>Dettagli</Trans>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container columnSpacing={3} alignItems="center">
                        <Grid item xs={12} sm={6} md={4}>
                            <ZPlayAutocomplete
                                fieldName={`${this.props.name}.country`}
                                label={t({
                                    id: "df-country",
                                    message: "Paese di origine"
                                })}
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger}
                                data={this.props.countryList}/>
                        </Grid>
                    </Grid>
                    <Grid container columnSpacing={3} rowSpacing={2}>
                        <Grid item xs={12} md={4}>
                            <ZPlayFormField
                                label={t({
                                    id: "df-production-year",
                                    message: "Anno di produzione"
                                })}
                                name={`${this.props.name}.productionYear`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ZPlayDatePicker
                                label={t({
                                    id: "df-release-date",
                                    message: "Data di uscita",
                                })}
                                name={`${this.props.name}.releaseDate`}
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Stack direction="row" alignItems="center" spacing={4}>
                                <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                                    <Trans id={"df-serie-label"}>Serie</Trans>
                                </Typography>
                                <RadioDefault
                                    {...this.props}
                                    name={`${this.props.name}.serie`}
                                    defaultValue={false}
                                    updateValue={this.updateValue}/>
                            </Stack>
                        </Grid>
                        {this.state.checkSerie && <>
                            <Grid item xs={12} md={4}>
                                <ZPlaySelect
                                    name={`${this.props.name}.serieTitle`}
                                    label={t({
                                        id: "df-serie-title",
                                        message: "Seleziona serie"
                                    })}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}>
                                        {this.props.seriesList.map((item, i) =>
                                            <option value={item.id}>{item.title[0].description}</option>
                                        )}
                                </ZPlaySelect>
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-season",
                                        message: "Stagione"
                                    })}
                                    name={`${this.props.name}.season`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={6} md={2}>
                                <ZPlayFormField
                                    label={t({
                                        id: "df-episode",
                                        message: "Episodio"
                                    })}
                                    name={`${this.props.name}.episode`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                        </>}
                        <Grid item xs={12}>
                            <Stack direction="row" alignItems="center" spacing={4}>
                                <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                                    <Trans id={"df-color-label"}>Colori</Trans>
                                </Typography>
                                <RadioDefault
                                    {...this.props}
                                    name={`${this.props.name}.color`}
                                    updateValue={() => ({})} />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ZPlayFormField
                                label={t({
                                    id: "df-duration-hours",
                                    message: "Ore"
                                })}
                                name={`${this.props.name}.durationInHours`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ZPlayFormField
                                label={t({
                                    id: "df-duration-minutes",
                                    message: "Minuti"
                                })}
                                name={`${this.props.name}.durationInMinutes`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ZPlayFormField
                                label={t({
                                    id: "df-duration-seconds",
                                    message: "Secondi"
                                })}
                                name={`${this.props.name}.durationInSeconds`}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ZPlaySelect
                                name={`${this.props.name}.ageClassification`}
                                label={t({
                                    id: "df-age-classification",
                                    message: "Restrizioni età"
                                })}
                                control={this.props.control}
                                formState={this.props.formState}
                                trigger={this.props.trigger}>
                                    <option value={AgeClassification.ALL}>Tutti</option>
                                    <option value={AgeClassification.OLDER_7}>Maggiori 7 anni</option>
                                    <option value={AgeClassification.OLDER_10}>Maggiori 10 anni</option>
                                    <option value={AgeClassification.OLDER_13}>Maggiori 13 anni</option>
                                    <option value={AgeClassification.OLDER_16}>Maggiori 16 anni</option>
                                    <option value={AgeClassification.OLDER_18}>Maggiori 18 anni</option>
                            </ZPlaySelect>
                        </Grid>
                    </Grid>
                    {!this.state.isLoading && <ZPlayChipList
                        chipsList={this.state.contentIssuesList}
                        selectedChipsIds={this.props.selectedIssues ? this.props.selectedIssues : []}
                        color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_CONTENT_ISSUES}
                        updateListCallback={this.props.updateContentIssues}
                        title={"Contenuti espliciti"}
                        titleId={"df-content-iussues-label"}
                        textId={"zpcl-content-iussues-explanation"}
                        text={"Scegli e seleziona i tag sottostanti per aggiungerli alla lista dei contenuti espliciti del tuo contenuto"}
                        showCreate={false}
                    />}
                    {!this.state.isLoading && <ZPlayChipList
                        chipsList={this.state.genreList}
                        selectedChipsIds={this.props.selectedGenres? this.props.selectedGenres : []}
                        color={process.env.REACT_APP_BACKOFFICE_CHIP_COLOR_GENRE}
                        updateListCallback={this.props.updateContentGenre}
                        createChipCallback={this.openCreateGenreModal}
                        title={"Genere"}
                        titleId={"df-genre-label"}
                        textId={"zpcl-genre-explanation"}
                        text={"Scegli e seleziona i generi sottostanti per aggiungerli alla lista dei generi del tuo contenuto. Puoi inoltre creare dei generi personalizzati schiacciando sull'apposito bottone."}
                    />}
                </AccordionDetails>
            </Accordion>
            {this.state.openCreateGenreModal &&
                <CreateAndEditGenreModal
                    createGenreCallback={this.createGenreCallback}
                    createGenreErrorCallback={this.createGenreErrorCallback}
                    closeModal={this.closeCreateGenreModal}/>}
            {this.state.isLoading && <ZPlayLoader />}
        </>)
    }
}
export default withSnackbar(DetailsData);
